'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002ecomponents$002e$002dAbstract$002dComponent from "./mealorama.components.-Abstract-Component.js";
import * as $j_mealorama$002epages$002e$002dCuisines$002dPage$0024$002dBackend from "./mealorama.pages.-Cuisines-Page$-Backend.js";
import * as $j_mealorama$002epages$002e$002dCuisines$002dPage$0024$002dState from "./mealorama.pages.-Cuisines-Page$-State.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_CuisinesPage$() {
  this.aoq = null;
  $n_Lmealorama_pages_CuisinesPage$ = this;
  $j_mealorama$002ecomponents$002e$002dAbstract$002dComponent.$f_Lmealorama_components_AbstractComponent__$init$__V(this);
  this.aoq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_component_builder_ComponentBuilder$Step1$().kx("CuisinesPage", new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$07eded5776954a9c145e92c329afd52873ad179c((() => new $j_mealorama$002epages$002e$002dCuisines$002dPage$0024$002dState.$c_Lmealorama_pages_CuisinesPage$State($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$())))).gJ(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$1$2) => new $j_mealorama$002epages$002e$002dCuisines$002dPage$0024$002dBackend.$c_Lmealorama_pages_CuisinesPage$Backend(_$1$2)))).od(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((_$2$2, _$3$2) => _$2$2.cA().aZU(_$3$2)))).gj($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_CtorType$Summoner$().qQ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_internal_Singleton$().on));
}
export { $c_Lmealorama_pages_CuisinesPage$ as $c_Lmealorama_pages_CuisinesPage$ };
$p = $c_Lmealorama_pages_CuisinesPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_CuisinesPage$;
/** @constructor */
function $h_Lmealorama_pages_CuisinesPage$() {
}
export { $h_Lmealorama_pages_CuisinesPage$ as $h_Lmealorama_pages_CuisinesPage$ };
$h_Lmealorama_pages_CuisinesPage$.prototype = $p;
$p.jI = (function(x$0) {
});
$p.jK = (function(x$0) {
});
$p.jJ = (function(x$0) {
});
$p.qs = (function() {
  return this.aoq.eh().C();
});
var $d_Lmealorama_pages_CuisinesPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_CuisinesPage$, "mealorama.pages.CuisinesPage$", ({
  KZ: 1,
  ai: 1,
  aL: 1
}));
export { $d_Lmealorama_pages_CuisinesPage$ as $d_Lmealorama_pages_CuisinesPage$ };
var $n_Lmealorama_pages_CuisinesPage$;
function $m_Lmealorama_pages_CuisinesPage$() {
  if ((!$n_Lmealorama_pages_CuisinesPage$)) {
    $n_Lmealorama_pages_CuisinesPage$ = new $c_Lmealorama_pages_CuisinesPage$();
  }
  return $n_Lmealorama_pages_CuisinesPage$;
}
export { $m_Lmealorama_pages_CuisinesPage$ as $m_Lmealorama_pages_CuisinesPage$ };
//# sourceMappingURL=mealorama.pages.-Cuisines-Page$.js.map
